import { SideNavMenu, SideNavMenuProps } from '@metrika/ui-kit/carbon';
import { styled } from '@metrika/ui-kit/emotion';
import { Add } from '@metrika/ui-kit/icons/carbon';
import React, { useLayoutEffect, useRef } from 'react';

/*
  This fix defaultExpanded prop that does not apply after comp mount if changed.
*/

const SideNavMenuStyled = styled(SideNavMenu)<{ indent?: number }>`
   span {
      padding-inline-start: ${(props) => (props.indent ? props.indent * 16 + 'px' : '0')};
   }
`;
const Wrapper = styled('div')`
   position: relative;
   .plus-button {
      position: absolute;
      width: 20px;
      height: 20px;
      top: 6px;
      right: 36px;
      bottom: 0;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      cursor: pointer;
      user-select: none;
      z-index: ${({ theme }) => theme.zIndex.overlay};
      svg {
         fill: ${({ theme }) => theme.colors.icon02};
      }
   }
`;

export const SideNavMenuFixed: React.FC<
   SideNavMenuProps & {
      indent?: number;
      onPlusClick?: React.MouseEventHandler<HTMLDivElement>;
   }
> = (props) => {
   const menuRef = useRef<HTMLButtonElement>();
   useLayoutEffect(() => {
      if (props.defaultExpanded && menuRef.current && menuRef.current.getAttribute('aria-expanded') !== 'true') {
         menuRef.current.click();
      }
   }, [props.defaultExpanded]);

   const { onPlusClick, children, ...rest } = props;

   return (
      <Wrapper>
         {onPlusClick && (
            <div className={'plus-button'} onClick={onPlusClick}>
               <Add size={16} />
            </div>
         )}
         {/* @ts-ignore */}
         <SideNavMenuStyled {...rest} ref={menuRef}>
            {children}
         </SideNavMenuStyled>
      </Wrapper>
   );
};
